module.exports = __webpack_public_path__ + "img/caso.e18a97fc.png";